export default {
  validDomain: /^([\w-]+(?:\.[\w-]+)*)((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{1,10}(?:\.[a-z]{2})?)$/i,
};
